import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";

interface ContactModalFieldType {
  name: string;
  type: InputfieldTypes;
  label: string;
  placeholder: string;
  required?: boolean;
}
export const addContactModalFields: ContactModalFieldType[] = [
  {
    name: "firstName",
    type: InputfieldTypes.TEXT,
    label: "First Name",
    placeholder: "Enter first name",
    required: true,
  },
  {
    name: "lastName",
    type: InputfieldTypes.TEXT,
    label: "Last Name",
    placeholder: "Enter last name",
    required: true,
  },
  {
    name: "phone",
    type: InputfieldTypes.ONCHANGE_TEXT,
    label: "Phone",
    placeholder: "Enter phone number",
  },
  {
    name: "email",
    type: InputfieldTypes.TEXT,
    label: "Email",
    placeholder: "Enter email address",
  },
  {
    name: "roleId",
    type: InputfieldTypes.SELECT_CUSTOM_FIELD,
    label: "Role",
    placeholder: "Select",
    customButtonLabel: "+ Add Role",
  },
];

export const notesField: ContactModalFieldType = {
  name: "notes",
  type: InputfieldTypes.TEXT_AREA,
  label: "Notes",
  placeholder: "Enter notes",
};

export const customStylingSelectField = {
  width: "100%",
  background: "#F1F5F9",
  borderColor: "#F1F5F9",
  textShadow: "none",
  color: "grey",
  display: "flex",
  justifyContent: "start",
};
